
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/affiliates",
      function () {
        return require("private-next-pages/partners/affiliates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/affiliates"])
      });
    }
  